import React from "react";
import Sidebar from "../../../../../../_legacy/Containers/Settings/sidebar.js";
import Loader from "../../../../../Common/Loader";

export const Layout = ({ isLoading, children }) => {
  return (
    <div id="content">
      <div className="container-fluid content setting-wrapper">
        <Sidebar />
        <div className="memberWalletOuter relative">{children}</div>
        <Loader showLoader={isLoading} isFullWidth={true} />
      </div>
    </div>
  );
};
